import personalFormFields from "./fields/personalInfo.json";
import familyFormFields from "./fields/familyRelation.json";
import educationFormFields from "./fields/professionalInfo.json";

export const Sections = {
  personal: {
    title: "Personal",
    key: "personal",
    formFields: personalFormFields,
  },
  family: {
    title: "Family",
    key: "family",
    formFields: familyFormFields,
  },
  education: {
    title: "Education",
    key: "education",
    formFields: educationFormFields,
  },
  skills: {
    title: "Skills",
    key: "skills",
    formFields: [{ key: "skills" }],
  },
};
